var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaptureImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 4,
    fill: "#04B7B1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22217_238641",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22217_238641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 27.5C23.25 27.5 24.3125 27.0625 25.1875 26.1875C26.0625 25.3125 26.5 24.25 26.5 23C26.5 21.75 26.0625 20.6875 25.1875 19.8125C24.3125 18.9375 23.25 18.5 22 18.5C20.75 18.5 19.6875 18.9375 18.8125 19.8125C17.9375 20.6875 17.5 21.75 17.5 23C17.5 24.25 17.9375 25.3125 18.8125 26.1875C19.6875 27.0625 20.75 27.5 22 27.5ZM22 25.5C21.3 25.5 20.7083 25.2583 20.225 24.775C19.7417 24.2917 19.5 23.7 19.5 23C19.5 22.3 19.7417 21.7083 20.225 21.225C20.7083 20.7417 21.3 20.5 22 20.5C22.7 20.5 23.2917 20.7417 23.775 21.225C24.2583 21.7083 24.5 22.3 24.5 23C24.5 23.7 24.2583 24.2917 23.775 24.775C23.2917 25.2583 22.7 25.5 22 25.5ZM14 31C13.45 31 12.9792 30.8042 12.5875 30.4125C12.1958 30.0208 12 29.55 12 29V17C12 16.45 12.1958 15.9792 12.5875 15.5875C12.9792 15.1958 13.45 15 14 15H17.15L19 13H25L26.85 15H30C30.55 15 31.0208 15.1958 31.4125 15.5875C31.8042 15.9792 32 16.45 32 17V29C32 29.55 31.8042 30.0208 31.4125 30.4125C31.0208 30.8042 30.55 31 30 31H14ZM30 29V17H25.95L24.125 15H19.875L18.05 17H14V29H30Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptureImg);
export default __webpack_public_path__ + "static/media/captureImg.0b1d380bf4117486530e68d6047bdc0f.svg";
export { ForwardRef as ReactComponent };